import css from 'styled-jsx/css';
import { colors, typography, zIndex } from '../../config/styles';
import { svgUrl } from '../../utils/staticUrls';

const heart = svgUrl('heart.svg');
const heartFill = svgUrl('Heart-filled-3.svg');
const heartAlt = svgUrl('heart3.svg');
const myList = svgUrl('myList.svg');
const myListFilled = svgUrl('myListFilled.svg');

const style = css`
  .container-my-lists {
    float: right;

    .csicon-my-list {
      background-image: url(${heart});
      background-repeat: no-repeat;
      background-size: contain;
      height: 27px;
      width: 29px;
      display: inline-block;
      vertical-align: middle;
      &.sodimac {
        background-image: url(${myList});
      }
      &.active {
        background-image: url(${heartFill});
        background-position: center;
        &.sodimac {
          background-image: url(${myListFilled});
        }
      }
    }
    .csicon-my-list-secondary {
      background-image: url(${heartAlt});
      background-repeat: no-repeat;
      background-size: contain;
      height: 20px;
      width: 20px;
      display: inline-block;
      vertical-align: middle;
      &.active {
        background-image: url(${heartFill});
        background-position: center;
      }
    }
    &.xlp-container {
      &.one-column {
        float: none;
        position: absolute;
        top: 30px;
        right: 33%;
        z-index: ${zIndex.xlp.myListsIcon};
        button {
          padding: 12px;
        }
        &.mobile {
          top: 26px;
          right: 3px;
        }
      }
      .csicon-my-list {
        height: 18px;
        width: 19px;
      }
    }
  }
  .my-lists-modal-container {
    .my-lists-modal-header {
      padding-bottom: 16px;
      @mixin mobileToTablet {
        padding-bottom: 0;
      }
      span {
        font-size: ${typography.xl2};
        line-height: 24px;
        margin-left: 16px;
        vertical-align: middle;
        font-weight: 700;
        color: ${colors.gray.shade15};
      }
      p {
        font-size: 14px;
        line-height: 17px;
        color: ${colors.gray.shade15};
        margin-top: 16px;
      }
      .csicon-my-list {
        height: 18px;
        width: 19px;
      }
    }
    .my-lists-button {
      margin-top: 23px;
      display: flex;
      justify-content: center;
      .box-button {
        max-width: 240px;
        width: 100%;
        display: flex;
      }
    }
    .my-lists-button.to_com {
      justify-content: center;
      @mixin tabletToDesktop {
        justify-content: flex-end;
      }
      .box-button {
        width: 100%;
        max-width: inherit;
        @mixin tabletToDesktop {
          max-width: inherit;
          width: inherit;
        }
        .tocom-save-button {
          height: 40px;
          width: 100%;
          color: ${colors.gray.shade66};
          background-color: ${colors.green.shade28};
          font-weight: 700;
          font-size: 16px;
          line-height: 16px;
          border-radius: 80px;
          @mixin tabletToDesktop {
            height: 32px;
            width: 115px;
            font-size: 14px;
          }
          &[disabled] {
            background-color: ${colors.gray.shade12};
            color: ${colors.gray.shade67};
          }
        }
      }
    }
  }
`;
export default style;
